import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'User/RefreshSession', method: 'GET', body: null, token: token })
}
